import { render } from "./BudgetTable.vue?vue&type=template&id=40039b58&scoped=true"
import script from "./BudgetTable.vue?vue&type=script&lang=js"
export * from "./BudgetTable.vue?vue&type=script&lang=js"

import "./BudgetTable.vue?vue&type=style&index=0&id=40039b58&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40039b58"]])

export default __exports__